import React from "react";

function Bridge(props) {
	return <p>Signing in ...</p>;
}

export default Bridge;
